import { render, staticRenderFns } from "./CreateMenu.vue?vue&type=template&id=216dd2dc&"
import script from "./CreateMenu.vue?vue&type=script&lang=js&"
export * from "./CreateMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports